export interface MenuItem {
  name: string;
  route: string;
  readOnly: boolean;
  openInNewTab: boolean;
}
